import { Coord } from '../../jscaip/Coord';
import { HexagonalUtils } from '../../jscaip/HexagonalUtils';
import { TableUtils } from '../../jscaip/TableUtils';
import { HexagonalGameState } from '../../jscaip/state/HexagonalGameState';
import { DvonnPieceStack } from './DvonnPieceStack';
export class DvonnState extends HexagonalGameState {
    alreadyPassed;
    static WIDTH = 11;
    static HEIGHT = 5;
    static EXCLUDED_SPACES = [2, 1];
    /* Returns the following board:
     *     W B B B W W B D B
     *    B B W W W B B W B B
     *   B B B B W D B W W W W
     *    W W B W W B B B W W
     *     W D W B B W W W B
     */
    static balancedBoard() {
        const _ = DvonnPieceStack.UNREACHABLE;
        const O = DvonnPieceStack.PLAYER_ZERO;
        const X = DvonnPieceStack.PLAYER_ONE;
        const S = DvonnPieceStack.SOURCE;
        return [
            [_, _, O, X, X, X, O, O, X, S, X],
            [_, X, X, O, O, O, X, X, O, X, X],
            [X, X, X, X, O, S, X, O, O, O, O],
            [O, O, X, O, O, X, X, X, O, O, _],
            [O, S, O, X, X, O, O, O, X, _, _],
        ];
    }
    static isOnBoard(coord) {
        if (coord.isNotInRange(DvonnState.WIDTH, DvonnState.HEIGHT)) {
            return false;
        }
        return DvonnState.balancedBoard()[coord.y][coord.x] !== DvonnPieceStack.UNREACHABLE;
    }
    static isNotOnBoard(coord) {
        return DvonnState.isOnBoard(coord) === false;
    }
    constructor(board, turn, 
    // Did a PASS move have been performed on the last turn?
    alreadyPassed) {
        super(turn, board, DvonnState.WIDTH, DvonnState.HEIGHT, DvonnState.EXCLUDED_SPACES, DvonnPieceStack.EMPTY);
        this.alreadyPassed = alreadyPassed;
    }
    getAllPieces() {
        const pieces = [];
        for (let y = 0; y < DvonnState.HEIGHT; y++) {
            for (let x = 0; x < DvonnState.WIDTH; x++) {
                const coord = new Coord(x, y);
                if (this.coordHasPieces(coord)) {
                    pieces.push(coord);
                }
            }
        }
        return pieces;
    }
    numberOfNeighbors(coord) {
        const neighbors = HexagonalUtils.getNeighbors(coord, 1);
        const occupiedNeighbors = neighbors.filter((c) => this.coordHasPieces(c));
        return occupiedNeighbors.length;
    }
    setAtUnsafe(coord, value) {
        const newBoard = TableUtils.copy(this.board);
        newBoard[coord.y][coord.x] = value;
        return new DvonnState(newBoard, this.turn, this.alreadyPassed);
    }
    isOnBoard(coord) {
        if (coord.isNotInRange(this.width, this.height)) {
            return false;
        }
        else {
            return this.getUnsafe(coord) !== DvonnPieceStack.UNREACHABLE;
        }
    }
    coordHasPieces(coord) {
        const optional = this.getOptionalPieceAt(coord);
        if (optional.isPresent()) {
            return optional.get().hasPieces();
        }
        else {
            return false;
        }
    }
}
